'use strict'

import './ext/NIM_Web_NIM_v7.8.0.js'
import './ext/NIM_Web_WebRTC_v7.8.0.js'
import store from '@/store'

// im 配置文件
const config = (token, appKey, account) => ({
  debug: true,
  appKey: appKey,
  account: account,
  token: token,
  onconnect: onConnect,
  onloginportschange: onLoginPortsChange,
  onwillreconnect: onWillReconnect,
  ondisconnect: onDisconnect,
  onerror: onError,
  onmsg: onmsg
})

function onLoginPortsChange (loginPorts) {
  console.log('当前登录帐号在其它端的状态发生改变了', loginPorts)
  // console.log(111)
  // netcall.hangup()
  // store.commit('prvateConsultation/setShowSaveModal', false)
}

function onConnect () {
  console.log('连接成功')
  store.commit('prvateConsultation/setimOnConnect', true)
}

function onWillReconnect (obj) {
  // 此时说明 SDK 已经断开连接, 请开发者在界面上提示用户连接已断开, 而且正在重新建立连接
  console.log('即将重连')
  console.log(obj.retryCount)
  console.log(obj.duration)
}

function onDisconnect (error) {
  // 此时说明 SDK 处于断开状态, 开发者此时应该根据错误码提示相应的错误信息, 并且跳转到登录页面
  console.log('丢失连接', error)
  if (error) {
    switch (error.code) {
      // 账号或者密码错误, 请跳转到登录页面并提示错误
      case 302:
        console.log('账号或者密码错误, 请跳转到登录页面并提示错误')
        break
      // 重复登录, 已经在其它端登录了, 请跳转到登录页面并提示错误
      case 417:
        console.log('重复登录, 已经在其它端登录了')
        break
      // 被踢, 请提示错误后跳转到登录页面
      case 'kicked':
        console.log('被踢, 请提示错误后跳转到登录页面')
        break
      default:
        break
    }
  }
  // store.commit('prvateConsultation/setShowSaveModal', false)
}

function onError (error) {
  console.log('我是错误的', error)
  // store.commit('prvateConsultation/setShowSaveModal', false)
}
function onmsg (message) {
  console.log('我是通话单', JSON.stringify(message))
  // TODO::
  // let params = {
  //   duration: message.attach.duration,
  //   ext: '音视频请求扩展信息',
  //   createtime: message.attach.time,
  //   members: message.attach.accounts,
  //   eventType: message.attach.netcallType,
  //   type: message.attach.type,
  //   channelId: message.attach.channelId,
  //   live: '0',
  //   status: 'SINGLE_PARTICIPATE'
  // }
  // store
  //   .dispatch('prvateConsultation/fetchVideoChannelIdReport', params)
  //   .then(res => {
  //     // 取消呼叫倒计时
  //   })

  // store.commit('prvateConsultation/setShowSaveModal', false)
}

// 初始化 im
const imInit = (token, appKey, account) => {
  var nim = NIM.getInstance(config(token, appKey, account))
  NIM.use(WebRTC)
  return nim
}
export default {
  imInit
}



// WEBPACK FOOTER //
// ./src/im/nim.js